import {Typography, useTheme} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';

enum ResultType {
  Win = 'win',
  Loss = 'loss',
  Tie = 'tie',
}

interface Props {
  locationType: 'home' | 'away';
  opponentName: string;
  teamScore: number;
  opponentScore: number;
  typographyVariant: 'h4' | 'h5';
}

const GameResult: React.FC<Props> = ({
  locationType,
  opponentName,
  teamScore,
  opponentScore,
  typographyVariant,
}) => {
  const {t} = useTranslation();
  const theme = useTheme();
  const resultType =
    teamScore > opponentScore
      ? ResultType.Win
      : teamScore < opponentScore
        ? ResultType.Loss
        : ResultType.Tie;
  const resultLabel =
    resultType === ResultType.Win
      ? t('gameResult.winAbbrev')
      : resultType === ResultType.Loss
        ? t('gameResult.lossAbbrev')
        : t('gameResult.tieAbbrev');

  return (
    <Typography variant={typographyVariant}>
      {locationType === 'home'
        ? t('gameResult.vsPrefix')
        : t('gameResult.atPrefix')}
      {`${opponentName}`}
      <span
        style={{
          padding: '0 8px',
          color:
            resultType === ResultType.Win
              ? theme.palette.success.main
              : resultType === ResultType.Loss
                ? theme.palette.error.main
                : theme.palette.grey[600],
        }}>
        {`${resultLabel}`}
      </span>
      {[opponentScore, teamScore].sort((a, b) => b - a).join(' - ')}
    </Typography>
  );
};

export default GameResult;
